import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, isEmpty, trim } from '@/common/js/utils'

export default {
  methods: {
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.pageSize = size
      this.pageIndex = 1
      this.getData()
    },
    searchFilterData(params) {
      this.pageIndex = 1
      this.getData(params)
    },
    filterData(params) {
      this.pageIndex = 1
      this.getData(params)
    },
    // 自定义列
    selectColumn(params) {
      this.columns = params.sort((a, b) => (a._time || 0) - (b._time || 0))
      this.modalColumn = false
    },
    getCustomStorage(name) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name)
      if (storage && isArray(storage[account])) return storage[account]
      else return []
    },
    setCustomStorage(name, list) {
      const account = Cookies.get('ch_op_id')
      let storage = getLocal(name)
      if (!storage) storage = {}
      storage[account] = list
      setLocal(name, storage)
    },
    inputTrim(key, val, obj, fixed, precision = 2) {
      if (isEmpty(val)) return val
      val = trim(val)
      if (fixed) {
        val = parseFloat(val) * 10 ^ precision
        val = Math.floor(val) / 10 ^ precision
      } else val = parseInt(val)
      obj[key] = isEmpty(val) ? 0 : val
    }
  },
  data() {
    return {
      loading: null,
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      tableList: [],
      tableCol: [],
      modalColumn: false // 自定义列
    }
  }
}
